import { render, staticRenderFns } from "./PhoneEightFive.vue?vue&type=template&id=40d36444&scoped=true"
import script from "./PhoneEightFive.vue?vue&type=script&lang=js"
export * from "./PhoneEightFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d36444",
  null
  
)

export default component.exports